export enum TRepairCalculationType {
  QuoteEstimate = 223940001,
  StandardReimbursementRate = 223940000,
}
